import React, { Component } from 'react';
import './Icon.css';
import Utils from '../../../base/Utils';

class Icon extends Component {
    availableSizes = ['Big', 'Medium', 'Small'];
    availableColors = ['Light', 'Dark', 'Good', 'Medium', 'Bad'];
    
    render() {
        var set = this.props.set || '';
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        var color = Utils.checkAvailability(this.availableColors, this.props.color, true);
        
        var classValue = "Icon icon " + set.toLowerCase() + " " + size + " " + color;
        
        var html = <i className={classValue}></i>;
        
        return html;
    }
}

export default Icon;
